module.exports = __webpack_public_path__ + "media/bootstrap-icons/eye-slash-fill-7bb492bf.svg";